(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-combo-cart-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('combo-cart-bar')) return;

    var CART_UPDATE = 'cart:update';

    function money(minorUnits) {
      var amount = Number(minorUnits || 0) / 100;
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: cur,
          maximumFractionDigits: 0,
        }).format(amount);
      } catch (e) {
        return '₹' + Math.round(amount).toLocaleString('en-IN');
      }
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 96);
    }

    class ComboCartBar extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.savingsMode = this.getAttribute('data-savings-mode') || 'amount';
        this.reviewEnabled = this.getAttribute('data-review') === 'true';
        this.compareCache = new Map();
        this.renderToken = 0;

        this.countEl = this.querySelector('[data-ccbar-count]');
        this.mrpEl = this.querySelector('[data-ccbar-mrp]');
        this.finalEl = this.querySelector('[data-ccbar-final]');
        this.savedEl = this.querySelector('[data-ccbar-saved]');
        this.savedTextEl = this.querySelector('[data-ccbar-saved-text]');
        this.toggleEl = this.querySelector('[data-ccbar-toggle]');
        this.reviewEl = this.querySelector('#ccbar-review');
        this.itemsEl = this.querySelector('[data-ccbar-items]');

        this._onCartUpdate = this._onCartUpdate.bind(this);
        this._onResize = this._onResize.bind(this);
        document.addEventListener(CART_UPDATE, this._onCartUpdate);
        window.addEventListener('resize', this._onResize);

        this.querySelector('[data-ccbar-viewcart]').addEventListener('click', (e) => { e.stopPropagation(); this.openCart(); });
        if (this.reviewEnabled) {
          // Clicking anywhere on the collapsed bar (except the View Cart button) toggles the
          // Review Cart panel — matches the live store, where the whole bar is the trigger.
          var pill = this.querySelector('.ccbar__pill');
          if (pill) pill.addEventListener('click', (e) => { if (e.target.closest('[data-ccbar-viewcart]')) return; this.toggleReview(); });
          var closeBtn = this.querySelector('[data-ccbar-collapse]');
          if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); this.collapse(); });
          if (this.itemsEl) this.itemsEl.addEventListener('click', (e) => this.onItemsClick(e));
        }

        this.updateOffset();
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener(CART_UPDATE, this._onCartUpdate);
        window.removeEventListener('resize', this._onResize);
      }

      _onResize() { this.updateOffset(); }

      _onCartUpdate(e) {
        var cart = e && e.detail && e.detail.resource;
        if (cart && cart.items && typeof cart.item_count === 'number') this.render(cart);
        else this.refresh();
      }

      /* Keep the bar above the fixed mobile bottom-nav (if present). */
      updateOffset() {
        var nav = document.getElementById('frido-bottom-nav');
        var visible = nav && getComputedStyle(nav).display !== 'none';
        var isDesktop = window.matchMedia('(min-width: 750px)').matches;
        // Mobile is full-bleed and flush: sit exactly on top of the bottom-nav when present,
        // else hug the very bottom. Desktop rides a little higher as a centred pill.
        var offset = visible ? nav.getBoundingClientRect().height : (isDesktop ? 40 : 0);
        this.style.setProperty('--ccbar-bottom', Math.round(offset) + 'px');
      }

      refresh() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => { if (cart) this.render(cart); })
          .catch(() => {});
      }

      async render(cart) {
        var token = ++this.renderToken;
        if (!cart || !cart.item_count) { this.hide(); return; }

        // Phase 1 (synchronous): count, the live total, line items, and reveal — no network,
        // so the bar appears instantly with the running total (no invisible-while-fetching gap).
        this.countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item added' : ' items added');
        this.finalEl.textContent = money(cart.total_price);
        if (this.reviewEnabled) this.renderItems(cart);
        this.updateOffset();
        this.show();

        // Phase 2 (async): struck MRP + savings need each variant's compare-at price, read
        // from product JSON (cached). Fill these in once resolved; a newer update supersedes.
        var totals = await this.computeTotals(cart);
        if (token !== this.renderToken) return;

        if (totals.mrp > totals.final) {
          this.mrpEl.textContent = money(totals.mrp);
          this.mrpEl.hidden = false;
        } else {
          this.mrpEl.hidden = true;
        }

        if (this.savingsMode !== 'none' && totals.savings > 0) {
          this.savedTextEl.textContent = this.savingsMode === 'amount' ? money(totals.savings) + ' saved' : 'Applied';
          this.savedEl.hidden = false;
        } else {
          this.savedEl.hidden = true;
        }
      }

      /* MRP = sum of each variant's compare-at price (fetched from product JSON, cached),
         falling back to the line's pre-discount price when there is no compare-at. */
      async computeTotals(cart) {
        var mrp = 0;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var ca = await this.compareAt(it.handle, it.variant_id || it.id);
          var unit = ca && ca > it.final_price ? ca : (it.original_price || it.final_price || it.price || 0);
          mrp += unit * (it.quantity || 1);
        }
        var final = cart.total_price;
        return { mrp: mrp, final: final, savings: Math.max(0, mrp - final) };
      }

      compareAt(handle, variantId) {
        if (!handle) return Promise.resolve(0);
        if (!this.compareCache.has(handle)) {
          this.compareCache.set(
            handle,
            fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => (r.ok ? r.json() : null))
              .then((p) => {
                var m = {};
                ((p && p.variants) || []).forEach((v) => { m[v.id] = v.compare_at_price || 0; });
                return m;
              })
              .catch(() => ({}))
          );
        }
        return this.compareCache.get(handle).then((m) => m[variantId] || 0);
      }

      renderItems(cart) {
        if (!this.itemsEl) return;
        var items = cart.items || [];
        this.itemsEl.innerHTML = items
          .map((it) => {
            var img = it.image || (it.featured_image && it.featured_image.url) || '';
            return (
              '<li class="ccbar__item" data-key="' + escapeHtml(it.key) + '">' +
              '<img class="ccbar__item-img" src="' + escapeHtml(sized(img, 96)) + '" alt="" width="48" height="48" loading="lazy">' +
              '<div class="ccbar__item-info">' +
              '<p class="ccbar__item-title">' + escapeHtml(it.product_title || it.title) + '</p>' +
              '<p class="ccbar__item-price">' + money(it.final_line_price) + '</p>' +
              '</div>' +
              '<div class="ccbar__qty">' +
              '<button type="button" data-ccbar-dec aria-label="Decrease quantity">−</button>' +
              '<span class="ccbar__qty-val">' + (it.quantity || 1) + '</span>' +
              '<button type="button" data-ccbar-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
              '</li>'
            );
          })
          .join('');
      }

      onItemsClick(e) {
        var dec = e.target.closest('[data-ccbar-dec]');
        var inc = e.target.closest('[data-ccbar-inc]');
        if (!dec && !inc) return;
        var li = e.target.closest('[data-key]');
        if (!li) return;
        var key = li.getAttribute('data-key');
        var valEl = li.querySelector('.ccbar__qty-val');
        var cur = parseInt(valEl && valEl.textContent, 10) || 1;
        var next = inc ? cur + 1 : cur - 1;
        this.changeQty(li, key, Math.max(0, next));
      }

      changeQty(li, key, qty) {
        var btns = li.querySelectorAll('button');
        btns.forEach((b) => (b.disabled = true));
        var body = { id: key, quantity: qty };
        var ids = this.cartSectionIds();
        if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            this.render(cart); // update the bar directly — never depend on the event round-trip
            this.dispatchCartUpdate(cart); // refresh cart icon + drawer contents (without reopening)
          })
          .catch(() => {})
          .finally(() => { btns.forEach((b) => (b.disabled = false)); });
      }

      cartSectionIds() {
        var ids = new Set();
        document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
          if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
        });
        return Array.from(ids).slice(0, 5);
      }

      /* Refresh the cart icon + drawer contents WITHOUT popping the drawer open
         (matches spectrum-cart-sync): strip `auto-open` for the synchronous dispatch. */
      dispatchCartUpdate(cart) {
        var drawer = document.querySelector('cart-drawer-component[auto-open]');
        var dialog = document.querySelector('dialog.cart-drawer__dialog');
        var suppress = drawer && !(dialog && dialog.hasAttribute('open'));
        if (suppress) drawer.removeAttribute('auto-open');
        document.dispatchEvent(
          new CustomEvent(CART_UPDATE, {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'combo-cart-bar',
              // `data.sections` lets the drawer's cart-items component morph to the new
              // state (and satisfies its `detail.data.sections` read). undefined is fine.
              data: { source: 'combo-cart-bar', sections: (cart && cart.sections) || undefined },
            },
          })
        );
        if (suppress) drawer.setAttribute('auto-open', '');
      }

      openCart() {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = '/cart';
      }

      toggleReview() {
        if (this.classList.contains('is-expanded')) this.collapse();
        else this.expand();
      }
      expand() {
        if (!this.reviewEl) return;
        this.reviewEl.hidden = false;
        this.classList.add('is-expanded');
        if (this.toggleEl) this.toggleEl.setAttribute('aria-expanded', 'true');
      }
      collapse() {
        if (!this.reviewEl) return;
        this.reviewEl.hidden = true;
        this.classList.remove('is-expanded');
        if (this.toggleEl) this.toggleEl.setAttribute('aria-expanded', 'false');
      }

      show() {
        this.hidden = false;
        // reveal on the next frame so the fade/slide transition runs
        requestAnimationFrame(() => this.classList.add('is-visible'));
      }
      hide() {
        this.classList.remove('is-visible', 'is-expanded');
        if (this.reviewEl) this.reviewEl.hidden = true;
        this.hidden = true;
      }
    }

    customElements.define('combo-cart-bar', ComboCartBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__customHeroCarouselInit) return;
  window.__customHeroCarouselInit = true;

  const SWIPE_THRESHOLD = 50;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setup = (root) => {
    if (root.dataset.chcReady === '1') return;
    root.dataset.chcReady = '1';

    const slides = Array.from(root.querySelectorAll('.custom-hero-carousel__slide'));
    if (slides.length === 0) return;

    const track = root.querySelector('.custom-hero-carousel__track');
    const dots = Array.from(root.querySelectorAll('.custom-hero-carousel__dot'));
    const playPause = root.querySelector('.custom-hero-carousel__playpause');
    const prevBtn = root.querySelector('.custom-hero-carousel__arrow--prev');
    const nextBtn = root.querySelector('.custom-hero-carousel__arrow--next');
    const total = slides.length;

    // Seamless forward loop: clone the first slide and append it after the last, so
    // advancing past the last slide glides FORWARD into the clone (a visual copy of
    // slide 1) and then snaps back to the real first slide with no animation —
    // instead of rewinding the whole track backward.
    // Slides 2+ ship with data-src/data-srcset so they cannot compete with the LCP
    // image (loading="lazy" does not defer carousel siblings — they sit inside the
    // browser's lazy threshold). Swap the real attributes in when we're past the
    // critical window, or immediately if the slide is about to be shown.
    // <source> must be set before <img>, or the picture resolves the wrong candidate.
    const hydrateSlide = (slide) => {
      if (!slide || slide.dataset.chcHydrated === '1') return;
      slide.dataset.chcHydrated = '1';
      slide.querySelectorAll('source[data-srcset]').forEach((s) => {
        s.setAttribute('srcset', s.dataset.srcset);
        s.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) {
          img.setAttribute('srcset', img.dataset.srcset);
          img.removeAttribute('data-srcset');
        }
        // Drop lazy as we hydrate. These slides are off-screen in the track, so with
        // loading="lazy" still set the browser would hold the fetch until the slide
        // scrolls in — producing a blank frame on the first autoplay advance. We are
        // already past the LCP window here, so fetch them in the background now.
        img.removeAttribute('loading');
        img.setAttribute('src', img.dataset.src);
        img.removeAttribute('data-src');
      });
    };

    const hydrateAllSlides = () => slides.forEach(hydrateSlide);

    // Autoplay first advances at ~7s, so idle time after load is early enough.
    const scheduleHydration = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(hydrateAllSlides, { timeout: 2500 });
      } else {
        setTimeout(hydrateAllSlides, 1200);
      }
    };
    if (document.readyState === 'complete') scheduleHydration();
    else window.addEventListener('load', scheduleHydration, { once: true });

    let firstClone = null;
    let loopingForward = false;
    let pendingSnap = null;
    if (total > 1) {
      // Clone after hydration is wired: the clone is of slide 0, which is never deferred.
      firstClone = slides[0].cloneNode(true);
      firstClone.classList.add('custom-hero-carousel__slide--clone');
      firstClone.setAttribute('aria-hidden', 'true');
      firstClone.removeAttribute('id');
      firstClone.querySelectorAll('a, button, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      firstClone.querySelectorAll('img').forEach(function (img) { img.setAttribute('loading', 'lazy'); img.setAttribute('fetchpriority', 'low'); });
      firstClone.querySelectorAll('video').forEach(function (v) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} });
      track.appendChild(firstClone);
    }

    const autoplayEnabled = root.dataset.autoplay === 'true' && total > 1 && !reduceMotion;
    const intervalMs = parseInt(root.dataset.interval, 10) || 7000;

    let current = 0;
    let inViewport = false;
    let userPaused = false;
    let pointerX = null;
    let pointerStartTime = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    // A slide can carry a video for one breakpoint and a still image for the other.
    // A video scoped to the other breakpoint is hidden by CSS and must be treated as
    // absent here too: autoplay advances a video slide on the video's `ended` event,
    // and a hidden video never plays or ends, so the carousel would sit on that slide
    // forever. Everything that decides "is this a video slide?" goes through this.
    const videoFor = (slide) => {
      const video = slide && slide.querySelector('.custom-hero-carousel__video');
      if (!video) return null;
      const list = video.classList;
      if (list.contains('custom-hero-carousel__video--desktop-only') && isMobile()) return null;
      if (list.contains('custom-hero-carousel__video--mobile-only') && !isMobile()) return null;
      return video;
    };

    // Skip video loading entirely on slow connections / save-data so the
    // poster image stays as LCP and we don't waste mobile data.
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const saveData = conn && (conn.saveData === true || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || ''));

    const ensureVideoSrc = (slide) => {
      if (saveData) return null;
      const video = videoFor(slide);
      if (!video) return null;
      if (video.dataset.noSwap === '1' && video.src) return video;
      const desired = isMobile() ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (!desired) return video;
      const currentMatches = video.currentSrc === desired ||
        (video.src && video.src.indexOf(desired) !== -1);
      if (currentMatches) return video;
      video.src = desired;
      return video;
    };

    const playActiveVideo = () => {
      if (reduceMotion || !inViewport) return;
      const video = videoFor(slides[current]);
      if (!video) return;
      ensureVideoSrc(slides[current]);
      const markPlaying = () => video.classList.add('is-playing');
      if (video.readyState >= 3) markPlaying();
      else video.addEventListener('playing', markPlaying, { once: true });
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const pauseAllVideos = () => {
      slides.forEach((slide) => {
        const v = slide.querySelector('.custom-hero-carousel__video');
        if (v && !v.paused) v.pause();
      });
    };

    const updateDots = () => {
      dots.forEach((dot, idx) => {
        const distance = Math.abs(idx - current);
        dot.dataset.distance = String(Math.min(distance, 4));
        // Dynamic-bullets window: active + 1 normal + 1 small each side; anything
        // beyond COLLAPSES (width 0 + margin 0 + opacity 0 via the data-distance
        // "3"/"4" CSS) so it shrinks out / grows in smoothly instead of popping
        // via display:none. tabindex/aria-hidden keep collapsed dots out of the
        // tab order and a11y tree (matching the old display:none behaviour).
        const collapsed = distance >= 3;
        dot.tabIndex = collapsed ? -1 : 0;
        dot.setAttribute('aria-hidden', collapsed ? 'true' : 'false');
        dot.setAttribute('aria-selected', idx === current ? 'true' : 'false');
      });
    };

    const updateAriaHidden = () => {
      slides.forEach((slide, idx) => {
        const isActive = idx === current;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.classList.toggle('is-active', isActive);
        const cta = slide.querySelector('.custom-hero-carousel__cta');
        if (cta) {
          if (isActive) cta.removeAttribute('tabindex');
          else cta.setAttribute('tabindex', '-1');
        }
      });
    };

    const getStep = () => {
      const first = slides[0];
      const second = slides[1];
      if (first && second) {
        return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      }
      return first ? first.getBoundingClientRect().width : 0;
    };

    const applyTransform = () => {
      const step = getStep();
      track.style.transform = `translate3d(${-current * step}px, 0, 0)`;
    };

    const setPlayState = (state) => {
      root.style.setProperty('--chc-play-state', state);
    };

    let imageRAF = null;
    let imageStartTs = 0;
    let imagePausedAt = 0;
    let videoCleanup = null;

    const setProgress = (dot, pct) => {
      if (!dot) return;
      const clamped = Math.min(100, Math.max(0, pct));
      // Composited transform animation: 0..1 scale on the pseudo bar.
      dot.style.setProperty('--chc-progress-scale', (clamped / 100).toFixed(4));
    };

    const disarmProgress = () => {
      if (imageRAF) {
        cancelAnimationFrame(imageRAF);
        imageRAF = null;
      }
      imagePausedAt = 0;
      if (videoCleanup) {
        videoCleanup();
        videoCleanup = null;
      }
      dots.forEach(d => {
        d.classList.remove('is-progressing');
        d.style.removeProperty('--chc-progress-scale');
      });
    };

    const armProgress = () => {
      if (!autoplayEnabled) return;
      const dot = dots[current];
      if (!dot) return;

      disarmProgress();
      dot.classList.add('is-progressing');
      setProgress(dot, 0);

      const slide = slides[current];
      const video = videoFor(slide);

      if (video) {
        const onTimeUpdate = () => {
          if (dot !== dots[current]) return;
          if (!video.duration || !isFinite(video.duration) || video.duration <= 0) return;
          const pct = (video.currentTime / video.duration) * 100;
          setProgress(dot, pct);
        };
        const onEnded = () => {
          if (dot !== dots[current]) return;
          setProgress(dot, 100);
          next();
        };
        video.addEventListener('timeupdate', onTimeUpdate);
        video.addEventListener('ended', onEnded);
        onTimeUpdate();
        videoCleanup = () => {
          video.removeEventListener('timeupdate', onTimeUpdate);
          video.removeEventListener('ended', onEnded);
        };
      } else {
        imageStartTs = performance.now();
        imagePausedAt = 0;
        const tick = (now) => {
          if (dot !== dots[current]) return;
          if (userPaused || !inViewport) {
            imagePausedAt = now - imageStartTs;
            imageRAF = null;
            return;
          }
          const elapsed = now - imageStartTs;
          const pct = (elapsed / intervalMs) * 100;
          setProgress(dot, pct);
          if (pct >= 100) {
            imageRAF = null;
            next();
            return;
          }
          imageRAF = requestAnimationFrame(tick);
        };
        imageRAF = requestAnimationFrame(tick);
      }
    };

    const resumeImageProgress = () => {
      const dot = dots[current];
      if (!dot || !autoplayEnabled || imagePausedAt <= 0) return;
      const slide = slides[current];
      const video = videoFor(slide);
      if (video) return;
      imageStartTs = performance.now() - imagePausedAt;
      imagePausedAt = 0;
      const tick = (now) => {
        if (dot !== dots[current]) return;
        if (userPaused || !inViewport) {
          imagePausedAt = now - imageStartTs;
          imageRAF = null;
          return;
        }
        const elapsed = now - imageStartTs;
        const pct = (elapsed / intervalMs) * 100;
        setProgress(dot, pct);
        if (pct >= 100) {
          imageRAF = null;
          next();
          return;
        }
        imageRAF = requestAnimationFrame(tick);
      };
      imageRAF = requestAnimationFrame(tick);
    };

    // Settle an in-flight forward-loop glide instantly (jump to the real first slide,
    // no animation) — used before any new nav so a second click never rewinds the track.
    const finalizeForwardLoop = () => {
      if (pendingSnap) { const f = pendingSnap; pendingSnap = null; f(); }
    };

    const goTo = (idx) => {
      finalizeForwardLoop();
      // An explicit nav (dot / prev) supersedes any in-flight loop glide.
      loopingForward = false;
      track.style.transition = '';
      current = ((idx % total) + total) % total;
      // If the user navigates before the idle hydration runs, load this slide and the
      // next one now so they are never shown an empty frame.
      hydrateSlide(slides[current]);
      hydrateSlide(slides[(current + 1) % total]);
      applyTransform();
      updateDots();
      updateAriaHidden();
      pauseAllVideos();
      playActiveVideo();
      disarmProgress();
      if (autoplayEnabled && inViewport && !userPaused) {
        armProgress();
      }
    };

    const next = () => {
      // Rapid clicks: if a forward-loop glide is still gliding into the clone, finalize
      // it FIRST (instant snap to the real first slide) so this click steps forward one
      // slide instead of rewinding the whole track backward from the clone position.
      if (loopingForward) finalizeForwardLoop();
      // Forward wrap: from the last slide, glide into the appended clone (a copy of
      // slide 1), then snap to the real first slide with no animation. Feels like a
      // normal "next" rather than rewinding back to the start.
      if (firstClone && current === total - 1) {
        loopingForward = true;
        disarmProgress();
        const step = getStep();
        track.style.transition = '';
        track.style.transform = 'translate3d(' + (-total * step) + 'px, 0, 0)';
        current = 0;
        updateDots();
        updateAriaHidden();
        let fallback = null;
        const doSnap = () => {
          track.removeEventListener('transitionend', onEnd);
          if (fallback) { clearTimeout(fallback); fallback = null; }
          if (!loopingForward) return; // guard: runs once
          loopingForward = false;
          pendingSnap = null;
          track.style.transition = 'none';
          track.style.transform = 'translate3d(0px, 0, 0)';
          void track.offsetWidth; // reflow so the no-animation snap takes effect
          track.style.transition = '';
          pauseAllVideos();
          playActiveVideo();
          disarmProgress();
          if (autoplayEnabled && inViewport && !userPaused) armProgress();
        };
        const onEnd = (e) => { if (e && e.target !== track) return; doSnap(); };
        pendingSnap = doSnap;
        track.addEventListener('transitionend', onEnd);
        // Fallback: snap even if transitionend never fires (interrupted transition,
        // backgrounded tab). 640ms > the 600ms track transition.
        fallback = setTimeout(doSnap, 640);
        return;
      }
      goTo(current + 1);
    };
    const prev = () => goTo(current - 1);

    const startTimer = () => {
      if (!autoplayEnabled || userPaused || !inViewport) return;
      setPlayState('running');
      if (imagePausedAt > 0 && !imageRAF) {
        resumeImageProgress();
      } else if (!imageRAF && !videoCleanup) {
        armProgress();
      }
    };
    const stopTimer = () => {
      setPlayState('paused');
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        goTo(idx);
        stopTimer();
        startTimer();
      });
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { next(); stopTimer(); startTimer(); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { prev(); stopTimer(); startTimer(); e.preventDefault(); }
        else if (e.key === 'Home') { goTo(0); stopTimer(); startTimer(); e.preventDefault(); }
        else if (e.key === 'End') { goTo(total - 1); stopTimer(); startTimer(); e.preventDefault(); }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => { prev(); stopTimer(); startTimer(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => { next(); stopTimer(); startTimer(); });
    }

    if (playPause && autoplayEnabled) {
      playPause.hidden = false;
      playPause.addEventListener('click', () => {
        userPaused = !userPaused;
        playPause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        playPause.setAttribute('aria-label', userPaused ? 'Play autoplay' : 'Pause autoplay');
        if (userPaused) stopTimer();
        else startTimer();
      });
    }

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);
    root.addEventListener('focusin', stopTimer);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) startTimer();
    });

    // Pointer drag/swipe — works for touch, pen AND mouse (desktop click-drag),
    // matching the mweb swipe. Native image drag is blocked so a mousedown on the
    // banner image starts a slide drag rather than the browser's image drag-ghost.
    let suppressClick = false;
    let capturing = false;
    track.addEventListener('dragstart', (e) => e.preventDefault());
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return; // left button only
      pointerX = e.clientX;
      pointerStartTime = Date.now();
      capturing = false;
      stopTimer();
      // NOTE: do NOT setPointerCapture here — capturing on a plain click makes
      // the follow-up `click` fire on the track instead of the slide's <a>,
      // producing dead clicks. Capture only once a real drag begins (below).
    });
    track.addEventListener('pointermove', (e) => {
      if (pointerX === null || capturing) return;
      // Only treat it as a drag once movement passes the swipe threshold, so a
      // normal click (with tiny cursor movement) is never mistaken for a drag.
      if (Math.abs(e.clientX - pointerX) > SWIPE_THRESHOLD) {
        capturing = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    track.addEventListener('pointerup', (e) => {
      if (pointerX === null) return;
      const dx = e.clientX - pointerX;
      const quick = Date.now() - pointerStartTime <= 800;
      pointerX = null;
      if (capturing) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} capturing = false; }
      // Only a genuine swipe (past the threshold) navigates the carousel AND
      // suppresses the click; anything shorter stays a click so CTA links work.
      if (quick && Math.abs(dx) > SWIPE_THRESHOLD) {
        suppressClick = true;
        if (dx < 0) next(); else prev();
      }
      startTimer();
    });
    track.addEventListener('pointercancel', (e) => {
      pointerX = null;
      if (capturing) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} capturing = false; }
      startTimer();
    });
    // Suppress ONLY the click that immediately follows a real swipe.
    track.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
      suppressClick = false;
    }, true);

    // Defer initial video load past LCP. The poster image becomes the LCP
    // element; the video fetch waits until after `window.load` (or 600ms idle)
    // so the 3+ MB MP4 doesn't compete for bandwidth during first paint.
    const loadFirstVideo = () => {
      if (!inViewport) return;
      playActiveVideo();
    };
    const scheduleFirstVideo = () => {
      if (document.readyState === 'complete') {
        setTimeout(loadFirstVideo, 200);
      } else {
        window.addEventListener('load', () => setTimeout(loadFirstVideo, 200), { once: true });
      }
    };

    if ('IntersectionObserver' in window) {
      let firstLoadScheduled = false;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wasInViewport = inViewport;
          inViewport = entry.isIntersecting;
          if (inViewport) {
            setPlayState('running');
            if (!firstLoadScheduled) {
              firstLoadScheduled = true;
              scheduleFirstVideo();
            } else {
              playActiveVideo();
            }
            if (!wasInViewport && autoplayEnabled && !userPaused) armProgress();
          } else {
            setPlayState('paused');
            pauseAllVideos();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(root);
    } else {
      inViewport = true;
      setPlayState('running');
      scheduleFirstVideo();
      armProgress();
    }

    let resizeFrame = null;
    let wasMobile = isMobile();
    window.addEventListener('resize', () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        applyTransform();
        // Crossing the breakpoint can flip the active slide between video-driven and
        // timer-driven progress. Re-arm, or the slide keeps waiting on the advance
        // signal of the mode it just left and never moves on.
        const nowMobile = isMobile();
        if (nowMobile !== wasMobile) {
          wasMobile = nowMobile;
          pauseAllVideos();
          armProgress();
          playActiveVideo();
          return;
        }
        const video = videoFor(slides[current]);
        if (!video) return;
        if (video.dataset.noSwap === '1') return;
        const desired = isMobile() ? video.dataset.srcMobile : video.dataset.srcDesktop;
        if (desired && video.src !== desired) {
          video.src = desired;
          if (inViewport) video.play().catch(() => {});
        }
      });
    });

    updateDots();
    updateAriaHidden();
  };

  const init = () => {
    document.querySelectorAll('.custom-hero-carousel').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.custom-hero-carousel');
    if (root) setup(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sfs-hero"] && !Shopify.designMode) return;
  try {
    
  /* Lightweight carousel — scroll-snap track + click handlers on
     the two chevrons. Only attaches if there's >1 slide. */
  (function () {
    const sections = document.querySelectorAll('.sfs-hero[data-slide-count]');
    sections.forEach((section) => {
      const count = parseInt(section.dataset.slideCount || '0', 10);
      if (count < 2) return;
      const track = section.querySelector('[data-sfs-hero-track]');
      const slides = section.querySelectorAll('[data-sfs-hero-slide]');
      const prev = section.querySelector('[data-sfs-hero-prev]');
      const next = section.querySelector('[data-sfs-hero-next]');
      const dots = section.querySelectorAll('.sfs-hero__dot');
      if (!track || slides.length < 2) return;

      const scrollTo = (idx) => {
        const clamped = Math.max(0, Math.min(idx, slides.length - 1));
        const target = slides[clamped];
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      };
      const currentIndex = () => {
        const w = track.clientWidth;
        return w > 0 ? Math.round(track.scrollLeft / w) : 0;
      };

      prev && prev.addEventListener('click', () => scrollTo(currentIndex() - 1));
      next && next.addEventListener('click', () => scrollTo(currentIndex() + 1));

      track.addEventListener('scroll', () => {
        const idx = currentIndex();
        dots.forEach((d, i) => d.classList.toggle('sfs-hero__dot--active', i === idx));
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sm-accordion"] && !Shopify.designMode) return;
  try {
    
  /* Delegated from document rather than bound per row at load.
     Binding at load depends on the section markup existing when the compiled bundle runs,
     and on every earlier section's script in that shared bundle not having thrown — if any
     of them does, everything after it silently never binds. Delegation has neither
     dependency: the listener is attached once to a node that always exists, and it works
     for markup injected later by the theme editor too. */
  (function () {
    if (window.__smAccDelegated) return;
    window.__smAccDelegated = true;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.sm-acc__summary');
      if (!btn) return;
      var row = btn.closest('.sm-acc__row');
      var list = btn.closest('.sm-acc__list');
      if (!row || !list) return;

      var willOpen = !row.classList.contains('is-open');

      // Exclusive: only one body expanded per accordion.
      var siblings = list.querySelectorAll('.sm-acc__row');
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] === row) continue;
        siblings[i].classList.remove('is-open');
        var sb = siblings[i].querySelector('.sm-acc__summary');
        if (sb) sb.setAttribute('aria-expanded', 'false');
      }

      row.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sm-buy-bar"] && !Shopify.designMode) return;
  try {
    
  /* Delegated, for the same reason as the other sections on this page: no dependency on
     bind-time markup, and no dependency on every earlier script in the shared compiled
     bundle having survived. */
  (function () {
    if (window.__smBuyDelegated) return;
    window.__smBuyDelegated = true;

    /* `window.onCheckoutClick` is NOT the opener on this store. gokwik.liquid documents
       the real chain: triggerGokwikCustomCheckout() is the arg-free opener;
       gokwikCheckoutClickFn needs the button and throws if called bare; initCheckout
       no-ops. Checking for onCheckoutClick meant this never treated GoKwik as ready, so the
       click fell through to the href — which is why it added to the cart and stopped. */
    function gokwikReady() {
      return !!window.gokwikSdk || typeof window.triggerGokwikCustomCheckout === 'function';
    }

    /* Adding to the cart makes the drawer pop open on top of checkout. cart-drawer.js
       gates that on `this.hasAttribute('auto-open')` in #handleCartAdd, and its own
       re-open suppression is only 500ms — far shorter than two fetches. So the attribute
       is removed for the duration of the handoff and restored afterwards. That is
       deterministic, unlike racing a timer against the drawer. */
    function suspendAutoOpen() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer || !drawer.hasAttribute('auto-open')) return function () {};
      drawer.removeAttribute('auto-open');
      var restored = false;
      function restore() {
        if (restored) return;
        restored = true;
        drawer.setAttribute('auto-open', '');
      }
      // Restore on a timer as a backstop, in case the caller never gets there.
      setTimeout(restore, 4000);
      return restore;
    }

    function closeDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.close === 'function') { try { drawer.close(); } catch (err) {} }
    }

    /* Prefer clicking the hidden trigger: gokwik.liquid binds its own handler there, which
       also closes the cart drawer first (a <dialog> in the top layer would otherwise paint
       over GoKwik's overlay). Fall back to the opener chain if that binding has not run. */
    function openCheckout(trigger) {
      if (trigger && trigger.dataset.gkBound) { trigger.click(); return true; }
      if (typeof window.triggerGokwikCustomCheckout === 'function') { window.triggerGokwikCustomCheckout(); return true; }
      if (trigger && typeof window.gokwikCheckoutClickFn === 'function') { window.gokwikCheckoutClickFn(trigger); return true; }
      if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') { window.gokwikSdk.initCheckout(); return true; }
      return false;
    }

    document.addEventListener('click', function (e) {
      var cta = e.target && e.target.closest && e.target.closest('[data-sm-buy-cta]');
      if (!cta) return;

      var bar = cta.closest('[data-sm-buy]');
      var trigger = bar && bar.querySelector('[data-sm-gokwik]');
      var variantId = cta.getAttribute('data-variant-id');

      // No GoKwik on this store, or it has not loaded: let the href do its job and take the
      // shopper to Shopify checkout rather than swallowing the click.
      if (!gokwikReady() || !trigger || !variantId) return;

      e.preventDefault();
      if (cta.dataset.smBusy) return;
      cta.dataset.smBusy = '1';
      cta.setAttribute('aria-busy', 'true');
      cta.classList.add('is-loading');
      var restoreAutoOpen = suspendAutoOpen();

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      /* XHR, not fetch, and deliberately so. Three scripts in this theme monkey-patch
         window.fetch and react to any /cart/(add|change|update|clear) URL —
         spectrum-cart-behaviour.js, frido-free-gift.js and frido-atc-upsell-popup.js. One
         of them pops the cart drawer open, which then sits on top of GoKwik's overlay.
         Removing the drawer's `auto-open` attribute did not help because those handlers do
         not go through it. XMLHttpRequest is not patched, so none of them observe this
         request and the cart is prepared silently. */
      function post(url, body) {
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open('POST', url, true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.withCredentials = true;
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.responseText);
            else reject(new Error('HTTP ' + xhr.status));
          };
          xhr.onerror = function () { reject(new Error('network')); };
          xhr.send(body ? JSON.stringify(body) : null);
        });
      }

      // Clear then add, so the order is exactly this course — matching what the cart
      // permalink used to guarantee.
      post(root + 'cart/clear.js')
        .then(function () {
          return post(root + 'cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
        })
        .then(function () {
          // Belt and braces: if anything opened it anyway, shut it before handing off.
          closeDrawer();
          if (!openCheckout(trigger)) throw new Error('no opener');
        })
        .catch(function () {
          // Fall back to the href rather than leaving the shopper on a dead button. The
          // spinner stays up because a navigation is about to happen.
          window.location.href = cta.getAttribute('href');
        })
        .then(function () {
          // The spinner stays up until GoKwik has had a moment to paint its overlay —
          // clearing it the instant the opener returns would flash the label back for a
          // beat while the checkout is still arriving.
          setTimeout(function () {
            delete cta.dataset.smBusy;
            cta.removeAttribute('aria-busy');
            cta.classList.remove('is-loading');
          }, 900);
          // Give any late cart event time to pass before auto-open is live again.
          setTimeout(restoreAutoOpen, 1200);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sm-hero"] && !Shopify.designMode) return;
  try {
    
  /* Delegated for the same reason as the accordion: no dependency on bind-time markup or
     on earlier scripts in the shared compiled bundle having survived. */
  (function () {
    if (window.__smHeroDelegated) return;
    window.__smHeroDelegated = true;

    var scrollY = 0;
    function lock(on) {
      var b = document.body;
      if (on) {
        scrollY = window.scrollY;
        b.style.position = 'fixed';
        b.style.top = -scrollY + 'px';
        b.style.left = '0';
        b.style.right = '0';
        b.style.overflow = 'hidden';
      } else {
        b.style.position = '';
        b.style.top = '';
        b.style.left = '';
        b.style.right = '';
        b.style.overflow = '';
        window.scrollTo(0, scrollY);
      }
    }

    function parts(node) {
      var hero = node.closest('.sm-hero');
      if (!hero) return null;
      return {
        dialog: hero.querySelector('[data-sm-dialog]'),
        video: hero.querySelector('[data-sm-video]')
      };
    }

    function syncSound(p) {
      if (!p.dialog || !p.video) return;
      p.dialog.classList.toggle('is-muted', p.video.muted);
      var s = p.dialog.querySelector('[data-sm-sound]');
      if (s) s.setAttribute('aria-pressed', p.video.muted ? 'false' : 'true');
    }

    /* A native dialog cannot be closed and animated at the same time: close() removes it from
       the top layer immediately, so anything animating on the way out is simply never painted.
       The exit animation therefore runs FIRST and close() happens on animationend.

       The timeout is not belt-and-braces, it is load-bearing. animationend does not fire if
       the animation never starts — reduced-motion setups that force animations off, a browser
       without ::backdrop support, or the element not being painted at all. Without it the
       dialog would sit open with no way to dismiss it. */
    function close(p) {
      var d = p.dialog;
      if (!d) return;
      if (p.video) p.video.pause();
      if (!d.open) { lock(false); return; }
      if (d.classList.contains('is-closing')) return;

      var timer;
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        clearTimeout(timer);
        d.removeEventListener('animationend', onEnd);
        d.classList.remove('is-closing');
        lock(false);
        if (d.close) d.close();
        else d.removeAttribute('open');
      }

      // Only the dialog's own animation counts — the close and sound buttons inside it could
      // have animations of their own, and those bubble to here.
      function onEnd(e) { if (e.target === d) finish(); }

      d.classList.add('is-closing');
      d.addEventListener('animationend', onEnd);
      timer = setTimeout(finish, 400);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var opener = t.closest('[data-sm-open]');
      if (opener) {
        var p = parts(opener);
        if (!p || !p.dialog || !p.video) return;
        // Source is attached on first open only, so the file is never fetched for a
        // visitor who does not watch it.
        if (!p.video.src) p.video.src = p.video.getAttribute('data-src');
        // Muted on open, so sound is always the viewer's choice. It also means play() is
        // never blocked: autoplay policies only reject AUDIBLE playback, so the muted-retry
        // fallback this used to need is gone.
        p.video.muted = true;
        p.dialog.classList.remove('is-closing');
        if (p.dialog.showModal) p.dialog.showModal();
        else p.dialog.setAttribute('open', '');
        lock(true);
        p.video.currentTime = 0;
        p.video.play().catch(function () {});
        syncSound(p);
        return;
      }

      var closer = t.closest('[data-sm-close]');
      if (closer) { var pc = parts(closer); if (pc) close(pc); return; }

      var sound = t.closest('[data-sm-sound]');
      if (sound) {
        var ps = parts(sound);
        if (ps && ps.video) { ps.video.muted = !ps.video.muted; syncSound(ps); }
        return;
      }

      // Backdrop click: the dialog element itself is the event target.
      if (t.matches && t.matches('[data-sm-dialog]')) {
        var pb = parts(t);
        if (pb) close(pb);
      }
    });

    /* ESC closes a modal dialog natively and instantly, skipping the animation entirely.
       Cancelling that and routing through close() gives the key the same exit as the button.
       `cancel` does not bubble, so this listens in the capture phase. */
    document.addEventListener('cancel', function (e) {
      var d = e.target;
      if (!d || !d.matches || !d.matches('[data-sm-dialog]')) return;
      e.preventDefault();
      var p = parts(d);
      if (p) close(p);
    }, true);

    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-sm-dialog]')) {
        var p = parts(e.target);
        if (p && p.video) p.video.pause();
        lock(false);
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frido-pdp-specifications"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__frSpecInit) return;
    window.__frSpecInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('[data-fr-spec-trigger]') : null;
      if (!btn) return;
      var item = btn.closest('.fr-spec__item');
      var root = btn.closest('[data-fr-spec]');
      if (!item || !root) return;

      var open = item.classList.contains('is-open');
      // Single-open accordion, matching the reference behaviour.
      root.querySelectorAll('.fr-spec__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var t = el.querySelector('[data-fr-spec-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
